import * as React from "react";
import { deepDerefrencer, IFormField } from "../../../utils/form_factory";
import "mapbox-gl/dist/mapbox-gl.css";
import GeoLocator from "../GeoLocator/GeoLocator";

interface IFormInputGeoLocatorProps extends Partial<IFormField> {
  name: any;
  formControl: any;
  isDisabled?: boolean;
  isHidden?: boolean;
  modalId?: string;
  drawerZIndex?: number;
}

export const FormInputGeoLocator: React.FC<IFormInputGeoLocatorProps> = ({
  name,
  label,
  formControl,
  isDisabled,
  modalId,
  drawerZIndex,
}: IFormInputGeoLocatorProps) => {
  const [location, setLocation] = React.useState<any>(null);

  React.useEffect(() => {
    if (location) {
      formControl.setFieldValue(name, location);
    }
  }, [location]);

  return (
    <>
      <GeoLocator
        modalId={modalId}
        location={deepDerefrencer(formControl.values, name)}
        setLocation={setLocation}
        editable={true}
        isDisabled={isDisabled}
        drawerZIndex={drawerZIndex}
      />
    </>
  );
};
